export const UPDATE_PROPS = 'UPDATE_PROPS_IN_SUPPLIER_SEND_TEMPLATE_WIZARD';
export const LOADING_TEMPLATES = 'LOADING_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD';
export const TEMPLATES_LOADED = 'LOADED_TEMPLATES_SUPPLIER_SEND_TEMPLATE_WIZARD';
export const LOCATIONS_LOADED = 'LOCATIONS_LOADED_SUPPLIER_SEND_TEMPLATE_WIZARD';
export const PROCESSING_PARTNERS = 'PROCESSING_PARTNERS_SUPPLIER_SEND_TEMPLATE_WIZARD';
export const PARTNERS_PROCESSED = 'PARTNERS_PROCESSED_SUPPLIER_SEND_TEMPLATE_WIZARD';
export const SENDING_CONTRACTS = 'SENDING_CONTRACTS_SUPPLIER_SEND_TEMPLATE_WIZARD';
export const CONTRACTS_CREATED = 'CONTRACTS_CREATED_SUPPLIER_SEND_TEMPLATE_WIZARD';
export const GET_CONTRACT_REQUEST_INFO = '[supplier-wizard]GET_CONTRACT_REQUEST_INFO_SUPPLIER_WIZARD';
export const CLEAR_STORE = 'CLEAR_STORE_SUPPLIER_SEND_TEMPLATE_WIZARD';

export const RESET_TEMPLATE_SELECTION = '[supplier-wizard]RESET_TEMPLATE_SELECTION';
export const RESET_LOCATION_SELECTION = '[supplier-wizard]RESET_LOCATION_SELECTION';



// WEBPACK FOOTER //
// ./src/app/stores/contracting/supplier-wizard/constants.js